import { createInertiaApp, Link } from '@inertiajs/vue3';
import * as Sentry from '@sentry/vue';
import { createHead } from '@unhead/vue/client';
import axios from 'axios';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import VueSnip from 'vue-snip';
import SetupDayJs from './Plugins/dayjs';
import SetupFontAwesome from './Plugins/icons';
import SetupPrimeVue from './Plugins/prime-vue';

const setupVueApp = ({ el, App, props, plugin }) => {
  const head = createHead();

  const app = createApp({ render: () => h(App, props) })
    .use(plugin)
    .use(VueSnip)
    .use(head)
    .component('Link', Link);

  SetupPrimeVue(app);
  SetupFontAwesome(app);

  // Add global asset() helper method
  app.mixin({
    methods: {
      asset: window.asset,
    },
  });

  // Only setup ziggy route method when the blade layout has @routes() defined
  if (window.route) {
    app.mixin({ methods: { route: window.route } });
  }

  if (import.meta.env.VITE_SENTRY_VUE_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
    });
  }

  app.config.errorHandler = error => {
    if (import.meta.env.VITE_SENTRY_VUE_DSN) {
      Sentry.captureException(error);
    }

    console.error(error);
  };

  app.mount(el);
};

createInertiaApp({
  resolve: name => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
  setup: setupVueApp,
});

window.dayjs = SetupDayJs();

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.asset = path => {
  const prefix = import.meta.env.VITE_ASSET_URL || '';

  return prefix.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
};
